//  PC UI库
import {
  Button,
  Tabbar,
  TabbarItem,
  Popup,
  Collapse,
  CollapseItem,
  AddressList,
  AddressEdit,
  Tabs,
  Tab,
  Checkbox,
  Stepper,
  Image,
  PullRefresh,
  Form,
  Overlay,
  Field,
  Picker,
  Toast,
  DropdownMenu,
  DropdownItem,
  Empty,
  Switch,
  List, 
} from "vant";

const VantComponent = [
  Button,
  Tabbar,
  TabbarItem,
  Popup,
  Collapse,
  CollapseItem,
  AddressList,
  AddressEdit,
  Tabs,
  Tab,
  Checkbox,
  Stepper,
  Image,
  PullRefresh,
  Form,
  Overlay,
  Field,
  Picker,
  Toast,
  DropdownMenu,
  DropdownItem,
  Empty,
  Switch,
  List, 
];
export default function loadVantUi(app) {
  VantComponent.forEach((component) => {
    app.use(component);
  });
}
